import React from 'react';

import { connect } from 'react-redux';
import { Field, Formik } from 'formik';
import { Alert, AlertTitle } from '@material-ui/lab';

import TextField from '../../components/CstmTextField';
import ScreenWrapper from '../../components/ScreenWrapper';

import { login } from '../../actions/login.actions';

import { PAGES } from '../../config/constants';
import { IS_EMAIL } from '../../constants/validations';

const Login = ({ setPrevPage, tryLogin, showError, setResetPasswordPage }) => {
  const initialValues = {
    email: '',
    pms_password: '',
  };

  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
          lineHeight: 1.1,
        }}
      >
        Please enter your password for your profile.
      </h1>

      <ScreenWrapper step={3}>
        <Formik
          initialValues={initialValues}
          onSubmit={values => {
            tryLogin(values);
          }}
          validate={validate}
        >
          {({ handleSubmit }) => (
            <React.Fragment>
              {showError === true && (
                <React.Fragment>
                  <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Authentication Failed.
                  </Alert>
                  <br />
                </React.Fragment>
              )}

              <Field name="email" label="Email Address" component={TextField} required />

              <Field
                name="pms_password"
                label="Password"
                component={TextField}
                required
                type="password"
                style={{ marginTop: 10 }}
              />

              <div style={{ marginTop: 10 }}>
                <div style={{ float: 'left' }}>
                  <button type="button" className="cstm_btn cstm_btn-text" onClick={setPrevPage}>
                    Back
                  </button>
                </div>
                <div style={{ float: 'right' }}>
                  <button
                    type="button"
                    className="cstm_btn cstm_btn-blue"
                    onClick={setResetPasswordPage}
                  >
                    Reset Password
                  </button>
                  <button type="button" className="cstm_btn cstm_btn-blue" onClick={handleSubmit}>
                    Login
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const validate = values => {
  let errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (IS_EMAIL.test(values.email) === false) {
    errors.email = 'Invalid email format';
  }

  if (!values.pms_password) {
    errors.pms_password = 'Required';
  }

  return errors;
};

const mapState = state => {
  return {
    showError: state.form.showError,
  };
};

const mapDispatch = dispatch => {
  return {
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.BORROWER_INFO,
      });
    },
    setResetPasswordPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.RESET_PASS_1,
      });
    },
    tryLogin: values => {
      dispatch(login(values));
    },
  };
};

export default connect(mapState, mapDispatch)(Login);



// WEBPACK FOOTER //
// ./src/Screens/Login/index.js